module.exports = __webpack_public_path__ + "img/Engine assembly.b55b2cb7.jpg";